import { responseError } from '@/utils/errors';
import findResult, {
  findWithCode,
  assignIfExists,
  mapResults,
  selectableResult,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { states, updateStates } from '@/constants/lifecycle';
import actions, {
  themeCategories,
  themeLifeCycle,
} from '../constants';
import initialState, {
  activeTheme,
  findTheme,
  findThemes,
  newThemeProperties,
  pruneThemeErrors,
} from './state';

const updateThemesFilter = withDraft((draft, action) => {
  const item = findThemes(draft, action);
  item.filter = action.value;
});

const fetchThemes = withDraft((draft, action) => {
  const item = findThemes(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showThemes = withDraft((draft, action) => {
  const item = findThemes(draft, action);
  const currentTheme = action.results.find((r) => r.picked);
  if (currentTheme) {
    draft.theme = currentTheme.code;
  }
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, selectableResult)
    : mapResults([], action, selectableResult);
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showThemesError = withDraft((draft, action) => {
  const item = findThemes(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const closeThemes = withDraft((draft, { category }) => {
  draft.themes[category] = initialState.themes[category];
});

const handleEditTheme = withDraft((draft, action) => {
  const categories = findWithCode(draft.themes, themeCategories, action.code);
  draft.activeTheme = activeTheme();
  categories.forEach((category) => {
    const item = findResult(draft.themes, category, action.code);
    assignIfExists(item, {
      ...action.result,
      ...updateStates,
    });
  });
});

const handleUpdateThemeProperties = withDraft((draft, action) => {
  const item = findTheme(draft, action);
  assignIfExists(item, action.properties, themeLifeCycle, true);
});

const handleShowSaveTheme = withDraft((draft, action) => {
  const item = findTheme(draft, action);
  assignIfExists(draft.activeTheme, newThemeProperties(item, action));
});

const handleUpdateThemeEnabled = withDraft((draft, action) => {
  const item = findTheme(draft, action);
  item.updateStatus = states.PENDING;
});

const handleEditThemeEnabled = withDraft((draft, action) => {
  const item = findTheme(draft, action);
  assignIfExists(item, {
    ...action.result,
    ...updateStates,
  });
});

const handleEditThemeEnabledError = withDraft((draft, action) => {
  const item = findTheme(draft, action);
  item.updateStatus = states.NONE;
});

const applyTheme = withDraft((draft, action) => { draft.theme = action.theme.code; });

const updateTheme = withDraft((draft) => { draft.activeTheme.updateStatus = states.PENDING; });

const hideSaveTheme = withDraft((draft) => { draft.activeTheme = activeTheme(); });

const updateActiveThemeProperties = withDraft((draft, action) => {
  assignIfExists(draft.activeTheme, action.properties);
  draft.activeTheme.updateErrors = pruneThemeErrors(draft.activeTheme.updateErrors, action);
});

const editThemeError = withDraft((draft, action) => {
  assignIfExists(draft.activeTheme, {
    updateStatus: states.ERROR,
    updateErrors: [responseError(action)],
  });
});

const toggleThemesPresentation = withDraft((draft, action) => {
  const item = findThemes(draft, action);

  item.display = action.display;
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.results = [];
  item.count = 0;
  item.currentPage = 1;
  item.totalPages = 0;
});

export default {
  [actions.APPLY_THEME]: applyTheme,
  [actions.CLOSE_THEMES]: closeThemes,
  [actions.EDIT_THEME]: handleEditTheme,
  [actions.EDIT_THEME_ENABLED]: handleEditThemeEnabled,
  [actions.EDIT_THEME_ENABLED_ERROR]: handleEditThemeEnabledError,
  [actions.EDIT_THEME_ERROR]: editThemeError,
  [actions.FETCH_THEMES]: fetchThemes,
  [actions.HIDE_SAVE_THEME]: hideSaveTheme,
  [actions.REFRESH_THEMES]: fetchThemes,
  [actions.SHOW_SAVE_THEME]: handleShowSaveTheme,
  [actions.SHOW_THEMES]: showThemes,
  [actions.SHOW_THEMES_ERROR]: showThemesError,
  [actions.TOGGLE_THEMES_PRESENTATION]: toggleThemesPresentation,
  [actions.UPDATE_ACTIVE_THEME_PROPERTIES]: updateActiveThemeProperties,
  [actions.UPDATE_THEME]: updateTheme,
  [actions.UPDATE_THEME_ENABLED]: handleUpdateThemeEnabled,
  [actions.UPDATE_THEME_PROPERTIES]: handleUpdateThemeProperties,
  [actions.UPDATE_THEMES_FILTER]: updateThemesFilter,
};
